import { Component } from '@angular/core';
import { AcceptCookiesComponent } from '@ccab/components-lib';

// Definindo o enum para as opções de política
export enum PolicyOptions {
  Mandatory = 'mandatory',
  Analytics = 'analytics'
}

@Component({
  selector: 'app-preferences-modal',
  templateUrl: './preferences-modal.component.html',
  styleUrls: ['./preferences-modal.component.scss']
})
export class PreferencesModalComponent {
  public PolicyOptions = PolicyOptions;

  selectedOption: string = PolicyOptions.Mandatory;
  dialogRef: any;

  selectOption(option: string): void {
    this.selectedOption = option;
  }

  onAccept(): void {
    this.dialogRef.close(AcceptCookiesComponent);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  checkStates: { [key: string]: boolean } = {
    googleAnalytics: true,
    google: true,
    hotjar: true
  };

  toggleCheckbox(key: string) {
    this.checkStates[key] = !this.checkStates[key];
  }
}
